import DashboardCard from '../../dashboard/components/DashboardCard';
import type { AdminDashboardStats } from '../../../domain/superadmin/types';
import { cn } from '@/lib/utils';

const TONE: Record<string, string> = {
  basic: 'border-border text-secondary',
  pro: 'border-primary/30 text-primary',
  enterprise: 'border-brand-200 text-brand-700',
  clients: 'border-success/40 text-success',
};

export function AccountTypeSection({ rows }: { rows: AdminDashboardStats['accountTypes'] }) {
  const clients = rows.find((r) => r.key === 'clients');

  return (
    <DashboardCard title="Distribuição por tipo de conta" className="mb-s5">
      <p className="mb-s4 text-[12px] text-muted">No período · ativos, inativos e trial por plano</p>
      <div className="flex flex-col gap-s4 md:flex-row md:items-stretch">
        <div className="flex flex-1 flex-col items-center justify-center py-s6">
          <p className="font-mono text-[32px] font-semibold tracking-[-1px] text-default tabular-nums">
            {clients?.total ?? 0}
          </p>
          <p className="text-[11px] font-semibold uppercase tracking-[0.07em] text-muted">Total clientes</p>
        </div>
        <ul className="flex flex-1 flex-col gap-s2">
          {rows.filter((r) => r.key !== 'clients').map((row) => (
            <li key={row.key} className={cn('rounded-xl border bg-surface px-s4 py-s3', TONE[row.key])}>
              <div className="flex items-center justify-between gap-s2">
                <span className="text-[11px] font-semibold uppercase tracking-[0.07em]">{row.label}</span>
                <span className="font-mono text-[18px] font-semibold tabular-nums text-default">{row.total}</span>
              </div>
              <p className="mt-1 text-[12px]">
                <span className="text-success">{row.active} ativos</span>
                <span className="text-muted"> · </span>
                <span className="text-error">{row.inactive} inativos</span>
                <span className="text-muted"> · </span>
                <span className="text-warning-text">{row.trial} trial</span>
              </p>
            </li>
          ))}
        </ul>
      </div>
    </DashboardCard>
  );
}
